module.exports = __webpack_public_path__ + "static/media/email1.5270f079.png";